export default __webpack_public_path__ + "media/images/icons/calendar-926a0f638ef4b7847ed4ceb0300b2ad7.svg";